<div class="d-flex flex-column h-100 gap-2" *transloco="let t; prefix: 'fuelLevel'">
  <h1>{{ t('fuelLevels.title') }}</h1>
  <div class="fuel-levels container-fluid h-100">
    <div class="header">
      <div class="row">
        <div class="col-2 col-lg-3">{{ t('fuelLevels.table.assets') }}</div>
        <div class="col">{{ t('fuelLevels.table.fuelLevel') }}</div>
        <div class="col">{{ t('fuelLevels.table.distanceToEmpty') }}</div>
        <div class="col col-3">{{ t('fuelLevels.table.location') }}</div>
        <div class="col">{{ t('fuelLevels.table.timeStamp') }}</div>
      </div>
    </div>

    <div class="body" *ngIf="!isLoading && filteredFuelLevels.length > 0">
      <cdk-virtual-scroll-viewport itemSize="63" minBufferPx="315" maxBufferPx="630" class="viewport">
        <div *cdkVirtualFor="let item of filteredFuelLevels; let i = index;" (click)="selectFuelLevel(item)"
          class="clickable row" [ngClass]="{'active-table': item.id == selectedFuelLevelId}" [attr.data-id]="item.id">
          <div class="col-2 col-lg-3" [ngbTooltip]="item.assetName" placement="auto" container="body">
            <span class="text-truncate d-inline-block"><strong>{{item.assetName}}</strong></span>
          </div>
          <div class="col">
            <app-fuel-level-display [level]="item.fuelLevel"
              [threshold]="item.lowFuelLevelThreshold"></app-fuel-level-display>
          </div>
          <div class="col">{{getDistanceToEmpty(item.distanceToEmpty)}}</div>
          <div class="col-3" [ngbTooltip]="item.location" placement="top" container="body">
            <span class="text-truncate d-inline-block">{{item.location}}</span>
          </div>
          <div class="col">{{item.timeSent | dateFormat}}</div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100" *ngIf="isLoading">
      <span class="spinner-border"></span>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100"
      *ngIf=" !isLoading && filteredFuelLevels.length==0 && !hasError">
      <app-empty-state></app-empty-state>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100"
      *ngIf="!isLoading && hasError">
      <app-error-state></app-error-state>
    </div>
  </div>
</div>